export const initLinks = (selector: string = '[href^="#"]') => {
	const LinksObject = {
		_init(): void {
			this._bindClass();
			this._bindEvents()
		},
		_bindClass(): void {
			this.onClick = this.onClick.bind(this);
			this.scrollTo = this.scrollTo.bind(this);
		},
		_bindEvents(): void {
			document.querySelectorAll(selector).forEach((link) => {
				link.addEventListener('click', this.onClick);
			});
		},
		onClick(event: Event): void {
			const link = event.currentTarget as HTMLElement;
			const target= link
				? document.querySelector( link?.getAttribute('href') as string ) as HTMLElement
				: null;

			if ( target ) {
				event.preventDefault();
				this.scrollTo( target );
			}
		},
		isMobile(): boolean {

			return window.innerWidth < 1024;
		},
		scrollTo( target: HTMLElement ): void {
			console.log('scrollTo', target );

			const navigationOffset = this.isMobile() ? 100 : 200;
			const targetOffset = target.getBoundingClientRect().top + window.scrollY;

			window.scrollTo( {
				top: targetOffset - navigationOffset,
				behavior: 'smooth'
			} );
		}
	};

	LinksObject._init();
	return LinksObject;
};
